module.exports = __webpack_public_path__ + "media/KZ-KZY.9916e62e.ogg";